module.exports = __webpack_public_path__ + "img/Presentation5_old.98524f78.png";